import React, { useState } from "react";
import VisaApplicationProgramChoice from "../VisaApplicationChoice/VisaApplicationChoice";
import visaPrograms from "../../data/schema/application_type/visaPrograms";
import Reuse from "../SimpleForm/CaseReuse/Reuse";
import util from "../../global/utils/Helpers";
import DetermineVersionModal from "../DetermineVersionModal/DetermineVersionModal";

const VisaApplicationGrid = () => {
  const [reuseOpen, setReuseOpen] = useState(false);
  const [reuseFormType, setReuseFormType] = useState();
  const [version, setVersion] = useState(null);
  const [isReusable, setIsReusable] = useState(false);
  const [determineVersionModalOpen, setDetermineVersionModalOpen] =
    useState(false);
  const [reuseNew, setReuseNew] = util.useFunctionAsState(() =>
    console.log("default")
  );
  const [queryParameters, setQueryParameters] = useState({});

  const setReuseParameters = (formType, startNew, queryParameters) => {
    setReuseFormType(formType);
    setReuseNew(startNew);
    setQueryParameters(queryParameters);
  };

  const toggleReuse = () => {
    setDetermineVersionModalOpen(false);
    setReuseOpen(!reuseOpen);
  };

  const toggleDetermineVersionModal = () => {
    setDetermineVersionModalOpen(!determineVersionModalOpen);
  };

  const visaProgramChoices = visaPrograms.map((program, index) => {
    return (
      <VisaApplicationProgramChoice
        key={index}
        {...program}
        toggleReuse={toggleReuse}
        toggleDetermineVersionModal={toggleDetermineVersionModal}
        setIsReusable={setIsReusable}
        setReuseParameters={setReuseParameters}
      />
    );
  });

  const validSections = () => {
    const formValidSections = {
      9141: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F.a",
        "F.b/c",
        "F.d",
        "F.e",
        "G",
        "H",
        "APX A",
      ],
      "790A": [
        "II",
        "PQ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "ADD A Crops",
        "ADD B Place",
        "ADD B Housing",
        "ADD C Terms",
      ],
      "790AV2": [
        "II",
        "PQ",
        "A",
        "B",
        "C",
        "D",
        "E/F",
        "G",
        "H",
        "ADD A Crops",
        "ADD B Place",
        "ADD B Housing",
        "ADD C Terms",
      ],
      9035: ["A", "B", "C", "D", "E", "G"],
      9089: [
        "Preliminary",
        "A",
        "B",
        "C",
        "E",
        "F.a",
        "F.b",
        "F.c",
        "G",
        "H.c",
        "H.d",
        "H.e",
        "J",
        "APX B",
        "APX C",
        "APX D",
      ],
    };

    // Rolling back V3 H2A and disabling modal
    if (reuseFormType === "790A") {
      return formValidSections["790AV2"];
    }
    return formValidSections[reuseFormType];
  };

  return (
    <div className={"usa-application-container"}>
      {visaProgramChoices}
      {reuseOpen && (
        <Reuse
          open={reuseOpen}
          toggleReuse={toggleReuse}
          formType={reuseFormType}
          // Rolling back V3 H2A and disabling modal
          reuseVersion={reuseFormType === "790A" ? 2 : null}
          startNew={reuseNew}
          queryParameters={queryParameters}
          validSections={validSections()}
        />
      )}
      {determineVersionModalOpen && (
        <DetermineVersionModal
          open={determineVersionModalOpen}
          toggleModal={toggleDetermineVersionModal}
          toggleReuse={toggleReuse}
          isReusable={isReusable}
          version={version}
          setVersion={setVersion}
          openForm={reuseNew}
        />
      )}
    </div>
  );
};

export default VisaApplicationGrid;
